<div class="relative !rounded-lg bg-white"
    [ngClass]="isMainItem ? 'border-palette-blue-600 !border-2 shadow-[0px_1px_2px_0px_#B2DDFF]' : 'border-palette-gray-200 !border'">
    <a [routerLink]="genRouterLink(item.property_id, item.property_name, item.city_name)"
        [queryParams]="genQueryParams(item.property_id, item.property_name, item.city_name)"
        class="absolute top-0 right-0 left-0 bottom-0 z-[0]" (click)="cacheHotel(item)" target="_blank">
    </a>
    <!--<div [ngClass]="{ 'border border-palette-gray-200' : isLogin}"
        *ngIf="item.best_match && currentPage === 1 && numOfPropertiesAPI2 !== 0"
        class="!h-[26px] !px-2 !py-1 bg-gradient-to-br border border-palette-orange-dark-500 from-palette-orange-dark-400 to-palette-orange-dark-500 absolute z-[6] top-0 left-0 rounded-tl-md rounded-br-md">
        <p class="!h-[18px] font-inter !text-xs !font-medium !leading-[18px] text-palette-base-white">{{ 'DETAIL.BEST_MATCH' | translate }}</p>
    </div> -->
    <div *ngIf="item.resource_id == 0" class="flex justify-center items-center font-inter text-xs font-medium leading-[18px] text-white !px-2 !py-1 
            bg-palette-blue-600 absolute z-[6] top-0 left-0 rounded-tl-md rounded-br-md">
        {{ 'DETAIL.RECOMMENDED' | translate }}
    </div>
    <div class="max-md:!p-2 md:!p-4 md:flex bg-white relative shadow-sm bg-opacity-5 {{ !isLogin ? 'rounded-t-lg' : 'rounded-lg' }}">
        <div class="relative z-[5] max-md:!w-full md:w-1/3 md:max-w-[33.33%] md:min-w-[33.33%] max-md:!h-[148px]"
           [ngClass]="{
                'md:!max-h-[244px]': displayPolicy.length > 0,
                'md:!max-h-[212px]': (displayPolicy.length === 0),
             }">
            <img loading="lazy" *ngIf="item.property_image_overview_id"
                class="!h-full min-w-full !max-w-full border rounded-lg !object-cover cursor-pointer bg-palette-gray-200"
                src="{{baseImageId}}/{{item.property_image_overview_id}}.webp" (error)="replaceWithDefaultImage($event)"
                (click)="quickViewPhotos($event, checkImageList(item.property_image_urls, item.property_image_ids))">
            <img loading="lazy" *ngIf="!item.property_image_overview_id"
                class="!h-full min-w-full !max-w-full border rounded-lg !object-cover cursor-pointer bg-palette-gray-200"
                src="{{ item.property_image_overview_url}}" (error)="replaceWithDefaultImage($event)"
                (click)="quickViewPhotos($event, checkImageList(item.property_image_urls, item.property_image_ids))">
            <button (click)="handleBookmark($event)"
                class="max-md:!w-7 max-md:!h-7 hover:cursor-pointer flex items-center max-md:!p-1.5 max-md:rounded-md md:!w-9 md:!h-9 md:!p-2 md:rounded-lg absolute top-2 right-2 bg-[#10182866]">
                <i class="max-md:!text-base max-md:!leading-4 !text-xl !leading-5"
                    [ngClass]="{ 'sctr-icon-solid-bookmark text-palette-amber-400': isBookmarked, 'text-white sctr-icon-bookmark': !isBookmarked }">
                </i>
            </button>
            <!-- ✅ Promotion images -->
            <ng-container *ngIf="item?.badge_info">
                <div class="absolute bottom-2 left-2 flex z-10 rounded-sm"
                    (mouseover)="item.badge_info?.badge_info.showTooltip = true"
                    (mouseleave)="item.badge_info?.badge_info.showTooltip = false">
                    <div class="relative z-10">
                        <img class="!w-8 !h-8 !p-0.5 rounded" src="{{baseUrl}}/{{ item.badge_info.badge_info.avatar}}.webp" alt="">
                        <div *ngIf="item.badge_info?.badge_info.showTooltip"
                            class="absolute text-xs font-medium text-palette-gray-900 bg-palette-gray-50 
                                !px-3 !py-2 rounded shadow-md left-full bottom-0 ml-1 whitespace-nowrap z-10">
                            {{ item.badge_info.badge_info.name }}
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div [ngClass]="{'content-best_match': item.best_match && currentPage === 1 && numOfPropertiesAPI2 !== 0}"
            class="lg:relative max-md:!mt-2 md:!w-2/3 md:max-w-[calc(66.66%-16px)] md:min-w-[calc(66.66%-16px)] md:!ml-4 flex flex-col">
            <div class="flex">
                <div
                    class="w-full flex flex-col gap-1">
                    <!-- Property name + Star -->
                    <a [routerLink]="genRouterLink(item.property_id, item.property_name, item.city_name)"
                        [queryParams]="genQueryParams(item.property_id, item.property_name, item.city_name)"
                        (click)="cacheHotel(item)" target="_blank">
                        <div class="flex items-center gap-1 ">
                            <app-star [count]="item.star" starStyle="!gap-0.5"
                                iconStyle="sctr-icon-solid-star-01 text-palette-amber-400 text-lg">
                            </app-star>
                            <p [tooltip]="item.property_name" 
                                [isTruncated]="true"
                                class="max-md:!text-sm md:!text-lg font-inter !font-semibold text-palette-gray-900 items-center gap-[2px] relative z-[5]
                                inline-block overflow-hidden text-ellipsis whitespace-nowrap align-middle"
                                [attr.title]="item.property_name">
                                {{ getShortPropertyName(item.property_name) }}
                            </p>
                        </div>
                    </a>
                </div>
                <!-- reviews -->
                <div class="max-md:!w-[20%] 2xl:!w-[35%] xl:max-2xl:!w-[50%] md:max-xl:!w-[50%] md:!ml-2 relative">
                    <div class="max-md:relative md:!absolute md:!top-0 md:!right-0 flex justify-end items-center">
                        <div #ratingTemplate *ngIf="item.average_rating_point">
                            <div class="w-full flex flex-col items-end -scroll-mb-3 md:mb-0">
                                <!-- 1. Rating Score -->
                                <app-rating-score [rating]="item.average_rating_point"
                                    [style]="'max-md:absolute max-md:top-0 max-md:right-0 md:!ml-4 relative max-md:!px-2 max-md:!py-1 max-md:!text-xs max-md:!leading-[18px] md:!px-3 md:!py-1 md:!text-base md:!h-8 border border-palette-blue-600 text-palette-blue-600'"
                                    [tooltipStyle]="'bottom-1/2 right-[120%] translate-y-[50%] w-[150px] min-[370px]:w-[180px]'">
                                </app-rating-score>

                                <!-- 2. Rating Text -->
                                <p
                                    class="hidden md:block text-sm font-inter !font-semibold text-right text-palette-gray-900">
                                    {{ item.average_rating_text }}
                                </p>

                                <!-- 3. Number of reviews -->
                                <p
                                    class="text-xs font-inter !font-normal text-right text-palette-gray-500 mt-1 md:mt-0 md:mb-0">
                                    {{ item.num_of_ratings }} {{ 'DETAIL.REVIEW' | translate: { syntax:
                                    item.num_of_ratings > 1 ? 's' :
                                    '' } }}
                                </p>
                            </div>
                        </div>
                        <!-- <div class="flex justify-center" *ngIf="!item.average_rating_point">
                                    <p class="font-inter !text-sm !font-medium text-palette-gray-500 whitespace-nowrap">{{'COMMON.NEW_ON_SOCTRIP' | translate}}</p>
                                </div> -->
                        <div class="flex justify-center md:m-0 mt-2"
                            *ngIf="item.resource_id === 0 && !item.average_rating_point">
                            <p class="font-inter !text-sm !font-medium text-palette-gray-500 whitespace-nowrap">
                                {{'COMMON.NEW_ON_SOCTRIP' | translate}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="max-md:!h-[auto] md:!mt-2 md:!mb-1 md:flex justify-between">
                <div class="max-md:!w-[90%] md:!w-[80%] flex relative flex-col md:flex-row ">
                    <div *ngIf="item.address"
                        class="relative z-[5] max-md:!w-[80%] md:!w-auto flex align-middle">
                        <i
                            class="sctr-icon-marker-pin-01 max-md:!text-base !text-lg !leading-[18px] text-palette-gray-500"></i>
                        <!-- <ng-container *ngIf="placeAdress; else hotelAddress">
                            <div (click)="viewMap(item)"
                                class="hover:underline max-md:!leading-6 max-md:!text-xs md:!text-sm font-inter !font-medium text-palette-gray-500 !ml-1 md:truncate cursor-pointer"
                                [attr.title]="placeAdress">
                                {{ getShortAddress(placeAdress) }}
                            </div>
                        </ng-container>
                        <ng-template #hotelAddress>
                            <div (click)="viewMap(item)"
                                class="hover:underline max-md:!leading-6 max-md:!text-xs md:!text-sm font-inter !font-medium text-palette-gray-500 !ml-1 md:truncate cursor-pointer"
                                [attr.title]="item.address">
                                {{ getShortAddress(item.address) }}
                            </div>
                        </ng-template> -->
                        <div (click)="viewMap(item)"
                            class="hover:underline max-md:!leading-6 max-md:!text-xs md:!text-sm font-inter !font-medium text-palette-gray-500 !ml-1 truncate cursor-pointer"
                            [tooltip]="item.address" [isTruncated]="true" [theme]="TooltipTheme.DARK_LIGHT"
                            [position]="TooltipPosition.ABOVE">
                            {{ item.address }}
                        </div>
                    </div>
                    <div class="w-[45%] flex align-middle">
                        <p *ngIf="item.distance_from_center"
                            class="max-md:!text-xs md:!text-sm font-inter !font-medium text-palette-gray-500 w-[18px] text-center">
                            &nbsp;•&nbsp;
                        </p>
                        <div *ngIf="item.distance_from_center && item.distance_from_center !== 0 && item.distance_from_center !== '0'; else centerLocation"
                            class="max-md:!text-xs md:!text-sm font-inter !font-medium text-palette-gray-500 truncate">
                            {{ item.distance_from_center | number:'1.2-2' }} {{ 'DETAIL.KM_FROM_CENTRE' | translate }}
                        </div>
                        <ng-template #centerLocation>
                            <div class="w-full flex align-middle md:mb-0">
                                <p
                                    class="max-md:!text-xs md:!text-sm font-inter !font-medium text-palette-gray-500 w-[18px] text-center">
                                    &nbsp;•&nbsp;
                                </p>
                                <div class="max-md:!text-xs md:!text-sm font-inter !font-medium text-palette-gray-500 truncate max-lg:max-w-[150px] max-sm:max-w-none mxl:max-w-none relative z-[5]"
                                    [attr.title]="'DETAIL.KM_FROM_CENTRE_1' | translate">
                                    {{ 'DETAIL.KM_FROM_CENTRE_1' | translate }}
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div *ngIf="item.room_amenity_list.length > 0" class="relative max-md:flex flex-wrap !gap-0.5 max-md:!my-1 md:!hidden">
                <div *ngIf="showTooltip"
                    class="absolute z-10 bg-white text-black text-xs border rounded px-2 py-1 shadow-lg top-full left-1/2 -translate-x-1/2 mt-1">
                    {{ getAmenityTooltip(displayFacility1) }}
                </div>
                <app-tag *ngFor="let facility of displayFacility1.slice(0, 3)" type="normal"
                    [item]="facility.amenity_translated"></app-tag>
                <div *ngIf="displayFacility1.length > 3" (click)="showTooltip = !showTooltip;"
                    class="z-[5] h-[22px] w-[22px] flex items-center justify-center text-xs font-medium rounded-full bg-palette-gray-200 text-palette-gray-700">
                    +
                </div>
            </div>
            <div #facilityTemplate>
                <div #tag class="amenities max-md:!hidden !w-full relative ">
                    <ng-container *ngIf="displayFacility1.length > 0 || displayFacility2.length > 0">
                        <div #tagLine1 *ngIf="displayFacility1.length > 0" class="w-full flex">
                            <app-tag class="md:!mb-2" *ngFor="let facility of displayFacility1" type="normal"
                                [item]="facility.amenity_translated"></app-tag>
                        </div>
                        <div #tagLine2 *ngIf="displayFacility2.length > 0" class="relative w-full flex">
                            <app-tag class="md:!mb-2" *ngFor="let facility of displayFacility2" type="normal"
                                [item]="facility.amenity_translated"></app-tag>
                            <span (mouseenter)="onShowAmenities()"
                                (mouseleave)="onHideAmenities()" *ngIf="hasRemainingFacility"
                                class="md:!h-[22px] md:!py-[2px] md:!px-2 md:rounded-2xl md:!mr-2 font-inter !text-xs !font-medium
                                                        !leading-[18px] bg-palette-border-palette-gray-200 text-palette-gray-700 relative z-[5]">
                                {{ '+' + numberOverFacility }}
                            </span>
                        </div>
                        <div *ngIf="showAmenitiesPopup && hasRemainingFacility" class="absolute z-50 !mb-2 bg-palette-gray-500 shadow-lg rounded-lg !p-2">
                            <p class="font-semibold text-xs text-white">
                                {{remainingFacility}}
                            </p>
                        </div>
                    </ng-container>
                    <!-- <div
                        class="w-full flex flex-col gap-0.5">
                        <div #policy class="flex flex-col md:!flex-col gap-0.5 overflow-hidden">
                            <div *ngFor="let policy of displayPolicy" class="flex items-center gap-1 text-palette-green-600">
                                <i class="sctr-icon-check-circle-broken mt-0.5 text-palette-green-600 text-sm"></i>
                                <span class="font-normal text-xs">
                                    {{ policy.name }}
                                </span>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

            <div class="max-md:!mt-3 max-md:relative max-md:!h-6 md:flex md:justify-between price-hidden">
                <div class="max-md:!hidden">
                    <p class="md:!text-base font-inter !font-medium text-palette-gray-700">{{ item.room_type_name }}</p>
                </div>
                <!-- <span *ngIf="isLoadingPriceCache; then loading; else showPriceCache"></span> -->
                <!-- <div *ngIf="isPrice && !isLoadingAPI" class="max-md:absolute max-md:right-0">
                            <div *ngIf="item.origin_price" class="max-md:!text-sm max-md:!ml-0.5 md:!text-base md:!ml-0.5 line-through font-inter !font-normal !text-palette-gray-500">
                                <app-price-format [price]="item.origin_price"></app-price-format>
                            </div>
                        </div>  -->
            </div>
            <!-- Amenity -->
            <div class="w-full flex-1 flex flex-col justify-between">
                <div #container class="h-full flex justify-between md:flex relative">
                    <div class="flex flex-col flex-1 h-auto justify-between">
                        <!-- Room info -->
                        <div *ngIf="displayPolicy.length > 0 || item.room_info?.view?.room_view_translate || item.room_info" 
                            class="relative room room-background !py-2 !pl-3">
                            <ng-container *ngIf="item.room_info;">
                                <p class="max-sm:!max-w-[260px] max-md:!max-w-[390px] max-lg:!max-w-[260px] max-xl:!max-w-[310px] max-2xl:max-w-[260px] 2xl:max-w-[320px] font-medium text-sm text-palette-gray-900 line-clamp-1 overflow-hidden text-ellipsis whitespace-nowrap" 
                                    [tooltip]="roomName"  
                                    [isTruncated]="true">
                                    {{roomName}}
                                </p>
                                <ng-container *ngIf="room.includes(item.property_type_name); else infoHotel">
                                    <p class="view-room font-normal text-xs text-palette-gray-500 relative">                                       
                                        <span *ngIf="this.bedNames.length > 0"
                                            class="align-middle"> 
                                            {{this.bedNames[0]}}
                                            <i *ngIf="this.bedNames.length > 1" class="sctr-icon-alert-circle font-normal text-xs relative group">
                                                <p class="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:!block bg-white shadow-md text-palette-gray-800 text-xs !font-medium !font-inter rounded px-3 py-2 whitespace-nowrap z-10">
                                                    <ng-container *ngFor="let bed of this.bedNames; let i = index">
                                                        {{ bed }}<span *ngIf="i < this.bedNames.length - 1">, </span>
                                                    </ng-container>
                                                </p>
                                            </i>
                                        </span>
                                    </p>
                                </ng-container>
                                <ng-template #infoHotel>
                                    <p class="font-normal text-xs text-palette-gray-500 relative">
                                        <span *ngIf="item.room_info.num_of_bedroom" class="max-w-[200px] inline-block overflow-hidden text-ellipsis whitespace-nowrap align-middle">
                                            {{item.room_info.num_of_bedroom}} {{'COMMON.BED_ROOM' | translate: {syntax: item.room_info.num_of_bedroom > 1 ? 's': ''} }}
                                        </span> 
                                        <span *ngIf="item.room_info.num_of_bedroom && this.bedNames.length > 0"> • </span>
                                        <span *ngIf="this.bedNames.length > 0"> 
                                            {{this.bedNames.length}} {{'COMMON.BED' | translate: {syntax: this.bedNames.length > 1 ? 's': ''} }}
                                            <i *ngIf="this.bedNames.length > 1" class="sctr-icon-alert-circle font-normal text-xs relative group !py-1">
                                                <p class="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:!block bg-white shadow-md text-palette-gray-800 text-xs !font-medium !font-inter rounded px-3 py-2 whitespace-nowrap z-10">
                                                    <ng-container *ngFor="let bed of this.bedNames; let i = index">
                                                        {{ bed }}<span *ngIf="i < this.bedNames.length - 1">, </span>
                                                    </ng-container>
                                                </p>
                                            </i>
                                        </span>
                                    </p>
                                </ng-template>
                            </ng-container>
                            <div *ngIf="displayPolicy.length > 0 || item.room_info?.view?.room_view_translate"
                                class="policies">
                                <div #policy class="flex flex-col gap-0.5 overflow-hidden max-md:w-[calc(100%-150px)]">
                                    <div *ngIf="item.room_info?.view?.room_view_translate" 
                                        class="flex items-center gap-1 text-palette-green-600">
                                        <i class="sctr-icon-{{item.room_info.view.room_view_icon || 'compass-03'}} mt-0.5 text-palette-green-600 text-sm"></i>
                                        <span class="font-normal text-xs">
                                            {{ item.room_info.view.room_view_translate }}
                                        </span>
                                    </div>
                                    <div *ngFor="let policy of displayPolicy" class="flex items-center gap-1 text-palette-green-600">
                                        <i class="sctr-icon-check-circle-broken mt-0.5 text-palette-green-600 text-sm"></i>
                                        <span class="font-normal text-xs">
                                            {{ policy.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Hotel CTA Tag -->
                        <div *ngIf="displayBadges?.length > 0 && item?.total_price && item?.net_price"
                            class="flex items-center justify-between !mt-1" >
                            <div class="relative">
                                <!-- Scrollable badge list -->
                                <div #badgeContainer
                                    class="w-auto max-w-[300px] max-md:max-w-[170px] max-lg:max-w-[220px] flex items-center space-x-2 overflow-x-auto scroll-smooth no-scrollbar cursor-grab active:cursor-grabbing select-none relative z-[5]"
                                    style="scroll-behavior: smooth;" (mousedown)="startDrag($event)" (mousemove)="onDrag($event)" (mouseup)="stopDrag()"
                                    (mouseleave)="stopDrag()">
                                    <div *ngFor="let badge of displayBadges"
                                        class="shrink-0 px-2 py-1 rounded whitespace-nowrap text-[10px] leading-[10px] font-medium border flex items-center space-x-1"
                                        [ngStyle]="{
                                        'background-color': badge.bgColor,
                                        'color': badge.color,
                                        'border-color': badge.borderColor
                                        }">

                                        <!-- iconUrl -->
                                        <ng-container *ngIf="badge.iconUrl; else iconClass">
                                        <img [src]="badge.iconUrl" alt="badge icon" class="w-3 h-3 object-contain" />
                                        </ng-container>

                                        <!-- iconClass -->
                                        <ng-template #iconClass>
                                        <i [class]="badge.iconClass" [ngStyle]="{ color: badge.color }"></i>
                                        </ng-template>

                                        <span>{{ badge.label }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Right side: Label -->
                            <!-- <div class="ml-2 text-xs md:text-sm font-medium text-rose-500 whitespace-nowrap">
                                <p>Our last room!</p>
                            </div> -->
                        </div>
                    </div>
                    <div #containerPrice
                        class="max-md:absolute max-md:right-0 max-md:bottom-0 md:!w-[35%] md:mt-0 mt-2 md:flex md:items-end md:justify-end h-auto">
                        <div class="flex flex-col h-fit">
                            <span *ngIf="isLoading; then loading; else showPriceCache"></span>
                            <ng-template #loading>
                                <!-- <div class="max-md:relative md:!h-full flex justify-end md:items-end !pr-7">
                                                        <app-loading [style]="'!h-[50px] !w-[50px]'"></app-loading>
                                                    </div> -->
                            </ng-template>
                            <ng-template #showPriceCache>
                                <span *ngIf="isGetPrice; then succes; else fail"></span>
                                <ng-template #fail>
                                    <div *ngIf="item?.total_price"
                                        class="max-md:relative md:!h-full flex flex-col justify-end items-end gap-0.5 md:mt-0">
                                        <ng-container *ngIf="item?.percentage_off && item.percentage_off > 0">
                                            <div class="flex justify-end">
                                                <p
                                                    class="w-fit bg-blue-600 text-white text-xs font-medium !px-2 !py-1 rounded whitespace-nowrap md:mt-0">
                                                    {{ 'DETAIL.OFF' | translate: { syntax: item.percentage_off } }}
                                                </p>
                                            </div>
                                        </ng-container>
                                        <div class="flex flex-col flex-wrap justify-end items-end">
                                            <div *ngIf="+item.total_origin_price !== +item.total_price"
                                                class="text-xs md:text-base md:!ml-0.5 line-through !font-normal !text-palette-gray-500">
                                                <app-price-format [price]="item.total_origin_price"></app-price-format>
                                            </div>
                                            <div
                                                class="md:!ml-1.5 md:!leading-none flex items-center max-md:!text-base max-md:!leading-[24px] md:!text-2xl !font-bold !text-palette-orange-dark-500 !ml-0.5">
                                                <app-price-format [price]="item.total_price"></app-price-format>
                                            </div>
                                        </div>
                                        <div *ngIf="item?.total_price"
                                            class="font-inter text-[10px] md:text-[13px] font-normal !text-palette-gray-500 text-end whitespace-nowrap flex justify-end">
                                            {{'PAYMENT.TOTAL_NIGHT_AFTER_TAXE_FEE' | translate : {value: item.rental_night,
                                            syntax: item.rental_night>=2?'nights': 'night'} }}
                                        </div>
                                        <ng-container *ngIf="item.badge_info?.rank_info">
                                            <div class="w-fit rank-background !p-0.5 !h-6 flex items-center justify-end !gap-0.5 relative z-10"
                                                (mouseover)="item.badge_info?.rank_info.showTooltip = true"
                                                (mouseleave)="item.badge_info?.rank_info.showTooltip = false">
                                                <img class="!w-5 !h-5 !p-0.5 rounded" src="{{baseUrl}}/{{ item.badge_info.rank_info.avatar}}.webp" alt="">
                                                <p class="text-xs font-normal text-palette-gray-500">
                                                    {{ 'SEARCH_RESULT.DISCOUNT' | translate }}
                                                </p>
                                                <p class="text-sm font-semibold text-palette-gray-900 !pl-0.5 !pr-1">
                                                    {{ item.badge_info.rank_info.reduce_amount | currencyConversion }}
                                                </p>
                                                <div *ngIf="item.badge_info?.rank_info.showTooltip"
                                                    class="absolute text-xs font-medium text-palette-gray-900 bg-palette-gray-50 
                                                        !px-3 !py-2 rounded shadow-md bottom-full mb-2 whitespace-nowrap z-[10]">
                                                    {{ item.badge_info.rank_info.name }}
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div *ngIf="!item.net_price"
                                        class="max-md:relative md:!h-full flex justify-end md:items-end">
                                        <div class="text-sm font-semibold text-center text-palette-gray-500 border-2 border-palette-gray-500 rounded-md px-4 py-2 opacity-50"
                                            style="box-shadow: 2px 1px 7px 0px rgba(0, 0, 0, 0.10);">
                                            {{ 'DETAIL.SOLD_OUT' | translate }}
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template #succes>
                                    <div class="max-md:relative md:!h-full flex justify-end md:items-end !pr-7">
                                        <!-- <app-loading [style]="'!h-[50px] !w-[50px]'"></app-loading> -->
                                    </div>
                                </ng-template>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div *ngIf="!isGetPrice && !item.total_price && !isLoading"
                    class="px-2 py-1 text-sm w-full h-8 border rounded-lg font-medium"
                    style="background-color: #FFFAEB; border-color: #FFFAEB; color: #DC6803; opacity: 0.8;">
                    <span>
                        {{ 'DETAIL.FULL_BOOKING' | translate }}
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!isLogin" class="h-[60px] w-auto bg-white px-2 py-1 md:!px-4 md:!py-3 rounded-b-lg">
        <div class="bg-palette-blue-50 rounded-lg h-full flex items-center">
            <div class="font-inter text-xs md:text-sm flex !gap-3 !px-3">
                <span class="font-medium text-palette-gray-700">{{ 'DETAIL.GET_MEMBER_DISCOUNT' | translate }}</span>
                <div class="flex items-center !gap-1 cursor-pointer !z-[5]" (click)="onSignIn()">
                    <span class="font-semibold text-palette-blue-600 hover:underline"> {{ 'DETAIL.SIGN_IN' | translate
                        }} </span>
                    <i class="sctr-icon-arrow-narrow-right text-palette-blue-600 text-[16px]"></i>
                </div>
            </div>
        </div>
    </div>
</div>
<app-toast keyToast="rsc"></app-toast>